import CartPage from './pages/CartPage.vue';

const routes = [
  {
    path: '/cart',
    name: 'store-cart',
    component: CartPage,
    meta: {
      title: 'Mon Panier - Kingrecharges Store',
    }
  },
];

export default routes;
